
const ConditionalRender = ({ condition, children }) => {
    return condition && children
}

export default ConditionalRender;